import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { multiLanguageAlphaNumericRegexHelper } from 'remarketing-angular-library';
import { AsyncPipe } from '@angular/common';
import { CharacterCountDirective, CharacterCountComponent } from 'remarketing-ui-components-lib';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'lib-reply',
    templateUrl: './reply.component.html',
    styleUrls: ['./reply.component.scss'],
    imports: [TranslocoDirective, CharacterCountDirective, CharacterCountComponent, AsyncPipe, ReactiveFormsModule]
})
export class ReplyComponent {
  @Input() question: any;
  @Input() questionError: string;
  @Output() answer = new EventEmitter<string>();
  @Output() toggle = new EventEmitter<boolean>();
  answerValue: string;
  characterCountData: any;

  constructor(private readonly translocoService: TranslocoService) {
    this.translocoService.selectTranslateObject('UIComponents').subscribe(translatedObj => {
      this.characterCountData = translatedObj.characterCount;
    });
  }

  setAnswerValue(answer: string) {
    this.answerValue = multiLanguageAlphaNumericRegexHelper(answer);
  }

  submitAnswer() {
    this.answer.emit(this.answerValue);
  }

  cancel() {
    this.toggle.emit(false);
  }
}
